import React, { Component } from "react";

import Backend from "../utils/Backend";
import Notify from "../utils/Notify";
import Currency from "../utils/Currency";

import StatsCard from "./components/stats-cards/StatsCard";
import ManageCustomersTable from "./components/tables/manage-customers/ManageCustomersTable";

import CustomerCountyPieChart from "./components/CustomerCountyPieChart";

import FetchHelper from "../utils/FetchHelper";
import moment from "moment";

export default class ManageCustomers extends Component {
  constructor(props) {
    super(props);

    // this.state = {
    //   stats: null,
    // };

//     this.state = {
//   stats: null,
//   funnelStats: null,
//   funnelLoading: false,
//   startDate: "",
//   endDate: "",
// };

this.state = {
  stats: null,
  funnelStats: null,
  funnelLoading: false,
  startDate: "",
  endDate: "",
};

    this._handleTotalRecordsChange = this._handleTotalRecordsChange.bind(this);
    this._handleDateChange = this._handleDateChange.bind(this);
    this._generateFrontendFunnel = this._generateFrontendFunnel.bind(this);
    this._getPercentage = this._getPercentage.bind(this);
  }

  componentDidMount() {
    this._getStats();
  }

  _getStats() {
    this.setState({ isLoading: true });

    Backend.getCustomersStats()
      .then((stats) => {
        this.setState((prevState) => ({
          stats: {
            ...stats,
            customer_count:
              prevState.stats?.customer_count ?? stats?.customer_count,
          },
          isLoading: false,
        }));
      })
      .catch((error) => {
        Notify.error(error.message);
        this.setState({
          isLoading: false,
        });
      });
  }

  _handleTotalRecordsChange(totalRecords) {
    this.setState((prevState) => ({
      stats: {
        ...(prevState.stats || {}),
        customer_count: totalRecords,
      },
    }));
  }


























  _handleDateChange(field, value) {
  this.setState({
    [field]: value,
  });
}

_getPercentage(value, total) {
  if (!total || total <= 0) {
    return "0.00";
  }

  return ((Number(value || 0) / Number(total)) * 100).toFixed(2);
}

// _isAfterClosingHour(dateValue) {
//   if (!dateValue) {
//     return false;
//   }

//   const date = new Date(dateValue);

//   if (Number.isNaN(date.getTime())) {
//     return false;
//   }

//   const hours = date.getHours();
//   const minutes = date.getMinutes();

//   return hours > 21 || (hours === 21 && minutes >= 30);
// }

_isAfterClosingHour(dateValue) {
  if (!dateValue) {
    return false;
  }

  const date = new Date(dateValue);

  if (Number.isNaN(date.getTime())) {
    return false;
  }

  const hours = date.getHours();
  const minutes = date.getMinutes();

  const isAfter930PM = hours > 21 || (hours === 21 && minutes >= 30);
  const isBefore10AM = hours < 10;

  return isAfter930PM || isBefore10AM;
}

_getCounty(customer) {
  const address =
    customer?.address ||
    customer?.user?.address ||
    customer?.default_address ||
    customer?.data?.customer_address ||
    customer?.addresses?.[0];

  return (
    customer?.county ||
    customer?.user?.county ||
    address?.county ||
    address?.state ||
    address?.city ||
    address?.administrative_area_level_2 ||
    address?.formatted_address ||
    "-"
  );
}

_hasAddress(customer) {
  return Boolean(
    customer?.address ||
      customer?.user?.address ||
      customer?.default_address ||
      customer?.data?.customer_address ||
      customer?.addresses?.length > 0
  );
}

_hasPhone(customer) {
  return Boolean(
    customer?.user?.phone_number ||
      customer?.phone_number ||
      customer?.mobile
  );
}

_isEmailVerified(customer) {
  return (
    customer?.user?.email_verified === true ||
    customer?.user?.email_verified === "true"
  );
}

_hasGoneHome(customer) {
  /**
   * Frontend-only estimate.
   * Accurate only if backend already sends home_opened_at / last_seen / app activity field.
   */
  return Boolean(
    customer?.home_opened_at ||
      customer?.went_home_at ||
      customer?.completed_onboarding_at ||
      customer?.user?.last_seen ||
      customer?.last_seen ||
      Number(customer?.order_count || 0) > 0 ||
      this._hasAddress(customer)
  );
}

async _generateFrontendFunnel() {
  try {
    const { startDate, endDate } = this.state;

    if (!startDate || !endDate) {
      Notify.error("Please select start date and end date.");
      return;
    }

    if (new Date(startDate) > new Date(endDate)) {
      Notify.error("Start date cannot be greater than end date.");
      return;
    }

    this.setState({ funnelLoading: true });

    /**
     * This fetches a large customer list and calculates funnel in frontend.
     * No backend change required.
     */
    const query = new URLSearchParams();

    query.append("page", "1");
    query.append("page_size", "99999");
    query.append("pagination_type", "page");
    query.append("ordering", "-created_at");

    const url = `${window.Api.Customers}?${query.toString()}`;

    const response = await FetchHelper.get(url, false);

    const customers = response?.results || response || [];

    const start = new Date(`${startDate}T00:00:00`);
    const end = new Date(`${endDate}T23:59:59`);

    const filteredCustomers = customers.filter((customer) => {
      const registeredAt =
        customer?.user?.created_at ||
        customer?.created_at ||
        customer?.user?.date_joined ||
        customer?.date_joined;

      if (!registeredAt) {
        return false;
      }

      const registeredDate = new Date(registeredAt);

      return registeredDate >= start && registeredDate <= end;
    });

    const totalRegistered = filteredCustomers.length;

    const emailVerified = filteredCustomers.filter((customer) =>
      this._isEmailVerified(customer)
    ).length;

    const phoneAdded = filteredCustomers.filter((customer) =>
      this._hasPhone(customer)
    ).length;

    const phoneAddedEmailNotVerified = filteredCustomers.filter((customer) => {
      return this._hasPhone(customer) && !this._isEmailVerified(customer);
    }).length;

    const wentHome = filteredCustomers.filter((customer) =>
      this._hasGoneHome(customer)
    ).length;

    const afterClosingHour = filteredCustomers.filter((customer) => {
      const registeredAt =
        customer?.user?.created_at ||
        customer?.created_at ||
        customer?.user?.date_joined ||
        customer?.date_joined;

      return this._isAfterClosingHour(registeredAt);
    }).length;

    const didNotContinue = filteredCustomers.filter((customer) => {
      return !this._hasGoneHome(customer);
    }).length;

    // const funnelStats = {
    //   total_registered: totalRegistered,
    //   email_verified: emailVerified,
    //   phone_added: phoneAdded,
    //   went_home: wentHome,
    //   did_not_continue: didNotContinue,
    //   after_closing_hour: afterClosingHour,
    //   customers: filteredCustomers,
    // };

    const funnelStats = {
      total_registered: totalRegistered,
      email_verified: emailVerified,
      phone_added: phoneAdded,
      phone_added_email_not_verified: phoneAddedEmailNotVerified,
      went_home: wentHome,
      did_not_continue: didNotContinue,
      after_closing_hour: afterClosingHour,
      customers: filteredCustomers,
    };

    this.setState({
      funnelStats,
      funnelLoading: false,
    });
  } catch (error) {
    console.error("Frontend funnel failed:", error);
    Notify.error(error.message || "Failed to generate funnel.");
    this.setState({
      funnelLoading: false,
    });
  }
}

























  render() {
    const { stats } = this.state;

    console.log("ManageCustomer stats: ", stats);


    if (!stats) {
      return null;
    }

    return (
      <div className="container">


        <div className="card card-custom mb-5">
  <div className="card-header">
    <div className="card-title">
      <h3 className="card-label">Customer Registration Funnel</h3>
    </div>
  </div>

  <div className="card-body">
    <div className="row align-items-end">
      <div className="col-lg-3 col-md-4 mb-3">
        <label className="font-weight-bold">Start Date</label>
        <input
          type="date"
          className="form-control"
          value={this.state.startDate}
          onChange={(e) =>
            this._handleDateChange("startDate", e.target.value)
          }
        />
      </div>

      <div className="col-lg-3 col-md-4 mb-3">
        <label className="font-weight-bold">End Date</label>
        <input
          type="date"
          className="form-control"
          value={this.state.endDate}
          onChange={(e) =>
            this._handleDateChange("endDate", e.target.value)
          }
        />
      </div>

      <div className="col-lg-3 col-md-4 mb-3">
        <button
          className="btn btn-primary"
          onClick={this._generateFrontendFunnel}
          disabled={this.state.funnelLoading}
        >
          {this.state.funnelLoading ? (
            <>
              <span className="spinner-border spinner-border-sm mr-2"></span>
              Generating...
            </>
          ) : (
            "Generate Funnel"
          )}
        </button>
      </div>
    </div>

    {this.state.funnelStats && (
      <>
        <div className="separator separator-dashed my-5"></div>

        <div className="row">
          <div className="col-lg-3 col-md-4 mb-4">
            <div className="bg-light-primary rounded p-4 text-center">
              <div className="font-size-h3 font-weight-bold">
                {this.state.funnelStats.total_registered}
              </div>
              <div className="text-muted">Registered</div>
              <small>100%</small>
            </div>
          </div>

          <div className="col-lg-3 col-md-4 mb-4">
            <div className="bg-light-success rounded p-4 text-center">
              <div className="font-size-h3 font-weight-bold">
                {this.state.funnelStats.email_verified}
              </div>
              <div className="text-muted">Email Verified</div>
              <small>
                {this._getPercentage(
                  this.state.funnelStats.email_verified,
                  this.state.funnelStats.total_registered
                )}
                %
              </small>
            </div>
          </div>

          <div className="col-lg-3 col-md-4 mb-4">
            <div className="bg-light-info rounded p-4 text-center">
              <div className="font-size-h3 font-weight-bold">
                {this.state.funnelStats.phone_added}
              </div>
              <div className="text-muted">Phone Added</div>
              <small>
                {this._getPercentage(
                  this.state.funnelStats.phone_added,
                  this.state.funnelStats.total_registered
                )}
                %
              </small>
            </div>
          </div>

          <div className="col-lg-3 col-md-4 mb-4">
            <div className="bg-light-danger rounded p-4 text-center">
              <div className="font-size-h3 font-weight-bold">
                {this.state.funnelStats.phone_added_email_not_verified}
              </div>
              <div className="text-muted">Phone Added, Email Not Verified</div>
              <small>
                {this._getPercentage(
                  this.state.funnelStats.phone_added_email_not_verified,
                  this.state.funnelStats.total_registered
                )}
                %
              </small>
            </div>
          </div>

          {/* <div className="col-lg-3 col-md-4 mb-4">
            <div className="bg-light-warning rounded p-4 text-center">
              <div className="font-size-h3 font-weight-bold">
                {this.state.funnelStats.went_home}
              </div>
              <div className="text-muted">Went Home</div>
              <small>
                {this._getPercentage(
                  this.state.funnelStats.went_home,
                  this.state.funnelStats.total_registered
                )}
                %
              </small>
            </div>
          </div> */}

          {/* <div className="col-lg-3 col-md-4 mb-4">
            <div className="bg-light-danger rounded p-4 text-center">
              <div className="font-size-h3 font-weight-bold">
                {this.state.funnelStats.did_not_continue}
              </div>
              <div className="text-muted">Did Not Continue</div>
              <small>
                {this._getPercentage(
                  this.state.funnelStats.did_not_continue,
                  this.state.funnelStats.total_registered
                )}
                %
              </small>
            </div>
          </div> */}

          <div className="col-lg-3 col-md-4 mb-4">
            <div className="bg-light-danger rounded p-4 text-center">
              <div className="font-size-h3 font-weight-bold">
                {this.state.funnelStats.after_closing_hour}
              </div>
              {/* <div className="text-muted">After 9:30 PM</div> */}
              <div className="text-muted">After 9:30 PM / Before 10 AM</div>
              <small>
                {this._getPercentage(
                  this.state.funnelStats.after_closing_hour,
                  this.state.funnelStats.total_registered
                )}
                %
              </small>
            </div>
          </div>
        </div>

        <div className="table-responsive mt-5">
          <table className="table table-bordered table-hover">
            <thead>
              <tr>
                <th>Funnel Step</th>
                <th>Users</th>
                <th>Percentage</th>
                <th>Meaning</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Registered Users</td>
                <td>{this.state.funnelStats.total_registered}</td>
                <td>100%</td>
                <td>Total users registered in selected date range</td>
              </tr>

              <tr>
                <td>Email Verified</td>
                <td>{this.state.funnelStats.email_verified}</td>
                <td>
                  {this._getPercentage(
                    this.state.funnelStats.email_verified,
                    this.state.funnelStats.total_registered
                  )}
                  %
                </td>
                <td>Users who verified their email</td>
              </tr>

              <tr>
                <td>Phone Number Added</td>
                <td>{this.state.funnelStats.phone_added}</td>
                <td>
                  {this._getPercentage(
                    this.state.funnelStats.phone_added,
                    this.state.funnelStats.total_registered
                  )}
                  %
                </td>
                <td>Users who added phone number</td>
              </tr>


              <tr>
                <td>Phone Added but Email Not Verified</td>
                <td>{this.state.funnelStats.phone_added_email_not_verified}</td>
                <td>
                  {this._getPercentage(
                    this.state.funnelStats.phone_added_email_not_verified,
                    this.state.funnelStats.total_registered
                  )}
                  %
                </td>
                <td>
                  Users who added phone number but have not verified their email
                </td>
              </tr>
{/* 
              <tr>
                <td>Went to Home</td>
                <td>{this.state.funnelStats.went_home}</td>
                <td>
                  {this._getPercentage(
                    this.state.funnelStats.went_home,
                    this.state.funnelStats.total_registered
                  )}
                  %
                </td>
                <td>
                  Estimated using last seen, address, order count, or home
                  activity field if available
                </td>
              </tr> */}
{/* 
              <tr>
                <td>Did Not Continue</td>
                <td>{this.state.funnelStats.did_not_continue}</td>
                <td>
                  {this._getPercentage(
                    this.state.funnelStats.did_not_continue,
                    this.state.funnelStats.total_registered
                  )}
                  %
                </td>
                <td>Users who registered but did not show app continuation activity</td>
              </tr> */}

              <tr>
                {/* <td>Registered After Closing Hour</td> */}
                <td>Registered After 9:30 PM / Before 10 AM</td>
                <td>{this.state.funnelStats.after_closing_hour}</td>
                <td>
                  {this._getPercentage(
                    this.state.funnelStats.after_closing_hour,
                    this.state.funnelStats.total_registered
                  )}
                  %
                </td>
                {/* <td>Users who registered after 9:30 PM</td> */}
                <td>Users who registered after 9:30 PM or before 10:00 AM</td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    )}
  </div>
</div>



        <div className="row wd-100">
          <div className="col-lg-4">
            {" "}
            <StatsCard
              data={[
                {
                  statsInfo: `${stats?.customer_count}`,
                  title: "Total Customers",
                  icon: (
                    <g
                      stroke="none"
                      strokeWidth={1}
                      fill="none"
                      fillRule="evenodd"
                    >
                      <rect x={0} y={0} width={24} height={24} />
                      <path
                        d="M4.3618034,10.2763932 L4.8618034,9.2763932 C4.94649941,9.10700119 5.11963097,9 5.30901699,9 L15.190983,9 C15.4671254,9 15.690983,9.22385763 15.690983,9.5 C15.690983,9.57762255 15.6729105,9.65417908 15.6381966,9.7236068 L15.1381966,10.7236068 C15.0535006,10.8929988 14.880369,11 14.690983,11 L4.80901699,11 C4.53287462,11 4.30901699,10.7761424 4.30901699,10.5 C4.30901699,10.4223775 4.32708954,10.3458209 4.3618034,10.2763932 Z M14.6381966,13.7236068 L14.1381966,14.7236068 C14.0535006,14.8929988 13.880369,15 13.690983,15 L4.80901699,15 C4.53287462,15 4.30901699,14.7761424 4.30901699,14.5 C4.30901699,14.4223775 4.32708954,14.3458209 4.3618034,14.2763932 L4.8618034,13.2763932 C4.94649941,13.1070012 5.11963097,13 5.30901699,13 L14.190983,13 C14.4671254,13 14.690983,13.2238576 14.690983,13.5 C14.690983,13.5776225 14.6729105,13.6541791 14.6381966,13.7236068 Z"
                        fill="#FF5E8A"
                        opacity="0.3"
                      />
                      <path
                        d="M17.369,7.618 C16.976998,7.08599734 16.4660031,6.69750122 15.836,6.4525 C15.2059968,6.20749878 14.590003,6.085 13.988,6.085 C13.2179962,6.085 12.5180032,6.2249986 11.888,6.505 C11.2579969,6.7850014 10.7155023,7.16999755 10.2605,7.66 C9.80549773,8.15000245 9.45550123,8.72399671 9.2105,9.382 C8.96549878,10.0400033 8.843,10.7539961 8.843,11.524 C8.843,12.3360041 8.96199881,13.0779966 9.2,13.75 C9.43800119,14.4220034 9.7774978,14.9994976 10.2185,15.4825 C10.6595022,15.9655024 11.1879969,16.3399987 11.804,16.606 C12.4200031,16.8720013 13.1129962,17.005 13.883,17.005 C14.681004,17.005 15.3879969,16.8475016 16.004,16.5325 C16.6200031,16.2174984 17.1169981,15.8010026 17.495,15.283 L19.616,16.774 C18.9579967,17.6000041 18.1530048,18.2404977 17.201,18.6955 C16.2489952,19.1505023 15.1360064,19.378 13.862,19.378 C12.6999942,19.378 11.6325049,19.1855019 10.6595,18.8005 C9.68649514,18.4154981 8.8500035,17.8765035 8.15,17.1835 C7.4499965,16.4904965 6.90400196,15.6645048 6.512,14.7055 C6.11999804,13.7464952 5.924,12.6860058 5.924,11.524 C5.924,10.333994 6.13049794,9.25950479 6.5435,8.3005 C6.95650207,7.34149521 7.5234964,6.52600336 8.2445,5.854 C8.96550361,5.18199664 9.8159951,4.66400182 10.796,4.3 C11.7760049,3.93599818 12.8399943,3.754 13.988,3.754 C14.4640024,3.754 14.9609974,3.79949954 15.479,3.8905 C15.9970026,3.98150045 16.4939976,4.12149906 16.97,4.3105 C17.4460024,4.49950095 17.8939979,4.7339986 18.314,5.014 C18.7340021,5.2940014 19.0909985,5.62999804 19.385,6.022 L17.369,7.618 Z"
                        fill="#FF5E8A"
                      />
                    </g>
                  ),
                },
              ]}
            />{" "}
          </div>
          <div className="col-lg-4">
            {" "}
            <StatsCard
              data={[
                {
                  statsInfo: `${Currency.format(stats?.total_earnings)}`,
                  title: "Revenue Generated",
                  icon: (
                    <g
                      stroke="none"
                      strokeWidth={1}
                      fill="none"
                      fillRule="evenodd"
                    >
                      <rect x={0} y={0} width={24} height={24} />
                      <path
                        d="M22,17 L22,21 C22,22.1045695 21.1045695,23 20,23 L4,23 C2.8954305,23 2,22.1045695 2,21 L2,17 L6.27924078,17 L6.82339262,18.6324555 C7.09562072,19.4491398 7.8598984,20 8.72075922,20 L15.381966,20 C16.1395101,20 16.8320364,19.5719952 17.1708204,18.8944272 L18.118034,17 L22,17 Z"
                        fill="#FF5E8A"
                      />
                      <path
                        d="M2.5625,15 L5.92654389,9.01947752 C6.2807805,8.38972356 6.94714834,8 7.66969497,8 L16.330305,8 C17.0528517,8 17.7192195,8.38972356 18.0734561,9.01947752 L21.4375,15 L18.118034,15 C17.3604899,15 16.6679636,15.4280048 16.3291796,16.1055728 L15.381966,18 L8.72075922,18 L8.17660738,16.3675445 C7.90437928,15.5508602 7.1401016,15 6.27924078,15 L2.5625,15 Z"
                        fill="#FF5E8A"
                        opacity="0.3"
                      />
                      <path
                        d="M11.1288761,0.733697713 L11.1288761,2.69017121 L9.12120481,2.69017121 C8.84506244,2.69017121 8.62120481,2.91402884 8.62120481,3.19017121 L8.62120481,4.21346991 C8.62120481,4.48961229 8.84506244,4.71346991 9.12120481,4.71346991 L11.1288761,4.71346991 L11.1288761,6.66994341 C11.1288761,6.94608579 11.3527337,7.16994341 11.6288761,7.16994341 C11.7471877,7.16994341 11.8616664,7.12798964 11.951961,7.05154023 L15.4576222,4.08341738 C15.6683723,3.90498251 15.6945689,3.58948575 15.5161341,3.37873564 C15.4982803,3.35764848 15.4787093,3.33807751 15.4576222,3.32022374 L11.951961,0.352100892 C11.7412109,0.173666017 11.4257142,0.199862688 11.2472793,0.410612793 C11.1708299,0.500907473 11.1288761,0.615386087 11.1288761,0.733697713 Z"
                        fill="#FF5E8A"
                        fillRule="nonzero"
                        transform="translate(11.959697, 3.661508) rotate(-270.000000) translate(-11.959697, -3.661508) "
                      />
                    </g>
                  ),
                },
              ]}
            />{" "}
          </div>
          <div className="col-lg-4">
            {" "}
            <StatsCard
              data={[
                {
                  statsInfo: `${stats?.sales_count} `,
                  title: "Orders Placed",
                  icon: (
                    <g
                      stroke="none"
                      strokeWidth={1}
                      fill="none"
                      fillRule="evenodd"
                    >
                      <rect x={0} y={0} width={24} height={24} />
                      <path
                        d="M5.94290508,4 L18.0570949,4 C18.5865712,4 19.0242774,4.41271535 19.0553693,4.94127798 L19.8754445,18.882556 C19.940307,19.9852194 19.0990032,20.9316862 17.9963398,20.9965487 C17.957234,20.9988491 17.9180691,21 17.8788957,21 L6.12110428,21 C5.01653478,21 4.12110428,20.1045695 4.12110428,19 C4.12110428,18.9608266 4.12225519,18.9216617 4.12455553,18.882556 L4.94463071,4.94127798 C4.97572263,4.41271535 5.41342877,4 5.94290508,4 Z"
                        fill="#FF5E8A"
                        opacity="0.3"
                      />
                      <path
                        d="M7,7 L9,7 C9,8.65685425 10.3431458,10 12,10 C13.6568542,10 15,8.65685425 15,7 L17,7 C17,9.76142375 14.7614237,12 12,12 C9.23857625,12 7,9.76142375 7,7 Z"
                        fill="#FF5E8A"
                      />
                    </g>
                  ),
                },
              ]}
            />{" "}
          </div>
        </div>


<div style={{ marginTop: "30px", marginBottom: "30px" }}> 
 <CustomerCountyPieChart />
</div>
             


        <ManageCustomersTable
          onTotalRecordsChange={this._handleTotalRecordsChange}
        />
      </div>
    );
  }
}
